import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (authService.isLoggedIn()) {
    const userRole = authService.getUserRole();

    if (localStorage.getItem('lockoutMessage')) {
      if (state.url !== '/login') {
        // Only redirect if not already on login
        
        router.navigate(['/login'], { replaceUrl: true });
      }
      return false;
    }

    if (state.url === '/login') {
      // router.navigate(['/dashboard'], { replaceUrl: true });
      switch (userRole) {
        case 2:
          router.navigate(['/dashboard'], { replaceUrl: true });
          break;
        case 4:
          router.navigate(['/dashboardZonalHead'], { replaceUrl: true });
          break;
        case 5:
          router.navigate(['/dashboardFinance'], { replaceUrl: true });
          break;
        case 6:
          router.navigate(['/nshLandingPage'], { replaceUrl: true });
          break;
        case 7:
          router.navigate(['/pmisLandingPage'], { replaceUrl: true });
          break;
        case 8:
          router.navigate(['/cosmLandingPage'], { replaceUrl: true });
      }

      return false;
    }
    return true;
  } else {
    if (state.url === '/login') {
      return true;
    }
    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }
};
